import api from './api';

export const lookupService = {
  // Dohvati sve lookup vrednosti za određenu tabelu
  getAllLookupValues: async (tableName) => {
    try {
      const response = await api.get(`/lookup/${tableName}`);
      
      // Backend vraća: { success, message, data: { count, data: [...] } }
      if (response && response.data && response.data.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else if (response && response.data && Array.isArray(response.data)) {
        return response.data;
      } else if (Array.isArray(response)) {
        return response;
      }
      
      return [];
    } catch (error) {
      console.error(`Error fetching lookup values for ${tableName}:`, error);
      // Mock podaci ako API ne radi
      return [
        { _id: '1', name: 'Frizerski salon', createdAt: new Date() },
        { _id: '2', name: 'Automehaničar', createdAt: new Date() },
        { _id: '3', name: 'Zubar', createdAt: new Date() },
      ];
    }
  },

  // Dohvati lookup vrednost po ID-u
  getLookupValueById: async (tableName, id) => {
    const response = await api.get(`/lookup/${tableName}/${id}`);
    return response.data;
  },

  // Kreiraj novu lookup vrednost
  createLookupValue: async (tableName, data) => {
    const response = await api.post(`/lookup/${tableName}`, data);
    return response.data;
  },

  // Ažuriraj lookup vrednost
  updateLookupValue: async (tableName, id, data) => {
    const response = await api.put(`/lookup/${tableName}/${id}`, data);
    return response.data;
  },

  // Obriši lookup vrednost
  deleteLookupValue: async (tableName, id) => {
    const response = await api.delete(`/lookup/${tableName}/${id}`);
    return response.data;
  },

  // Dohvati sve dostupne lookup tabele
  getAvailableLookupTables: async () => {
    try {
      const response = await api.get('/lookup/tables');
      
      // Axios automatski unwrapuje response, tako da su podaci u response.data
      let tables = [];
      
      if (response && response.data && response.data.tables) {
        tables = response.data.tables;
      } else if (response && response.tables) {
        tables = response.tables;
      } else if (response && response.data && Array.isArray(response.data)) {
        tables = response.data;
      } else if (Array.isArray(response)) {
        tables = response;
      } else if (response && typeof response === 'object') {
        // Pokušaj da pronađeš tabele u bilo kom polju
        for (const key in response) {
          if (Array.isArray(response[key])) {
            tables = response[key];
            break;
          }
        }
      }
      
      return { tables };
    } catch (error) {
      console.error('Error fetching lookup tables from backend:', error);
      // Mock podaci ako API ne radi
      return {
        tables: ['business_types', 'service_categories', 'appointment_statuses', 'payment_methods']
      };
    }
  },
};

export default lookupService;
